import React, { useEffect, useState,useContext } from "react";
import { CXR_TABS_NAME, REPORT_DONE_STATUS, SHOW_EXTERNAL_REPORTING_TO_USER, SHOW_SAVED_TAG_TABS, TAB_NAME, USERTYPES } from "../../../../constants/Constants";
import userContext from "../../../../context/users/UserContext";
import Resubmitted from "../../../../components/SVGComponents/Resubmitted";
import { statusStyle } from "../../helpers/ConstantStyles";
import { Icon } from "@fluentui/react";
import ReportDetailsBadge from "../ReportDetailsBage/ReportDetailsBadge";



const LabelsDetails = (props) => {

  const {roles,userId } = useContext(userContext);

  const index = props.index;
  return (
    <>
    <div className="studylist-super-admin-labels-container">
        <ReportDetailsBadge data={props.data} index={index} tabId={props.tabId} />
      </div>
    </>
    
  );
};

export default LabelsDetails;
